import { render, staticRenderFns } from "./doctorGrade.vue?vue&type=template&id=5f0a84f6&scoped=true"
import script from "./doctorGrade.vue?vue&type=script&lang=js"
export * from "./doctorGrade.vue?vue&type=script&lang=js"
import style0 from "./doctorGrade.vue?vue&type=style&index=0&id=5f0a84f6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a84f6",
  null
  
)

export default component.exports